import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

const TopOverageCard = ({ name, amount }) => {
  const theme = useTheme();
  const hasOverage = amount > 0;

  return (
    <Paper elevation={3} sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Typography variant="subtitle1" color="text.secondary">
        Top Overage
      </Typography>
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <Typography variant="h5" align="center">
          {name}
        </Typography>
        {hasOverage && (
          <Typography variant="h6" style={{ color: theme.palette.overage.main }}>
            {`$${amount.toFixed(2)}`}
          </Typography>
        )}
      </Box>
    </Paper>
  );
};

export default TopOverageCard;